import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import * as powerbi from "powerbi-client";
import { service, factories, models } from "powerbi-client";
import { finalize } from "rxjs";
import { PowerBiService } from "src/app/_services/power-bi.service";

@Component({
  selector: "app-cuadro-de-mandos",
  templateUrl: "./cuadro-de-mandos.component.html",
  styleUrls: ["./cuadro-de-mandos.component.css"],
})
export class CuadroDeMandosComponent {
  constructor(private powerBiService: PowerBiService) {}
  @ViewChild("reportContainer") reportContainer: ElementRef;
  report;

  ngOnInit(): void {

  }

  // Configuración para Power BI Embed (SE NECESITA CAMBIAR ESTOS DATOS PARA QUE FUNCIONE) 
  // embedConfig = {
  //   type: "report",
  //   id: "3a94a87e-a46e-4321-877a-c2819e369851", //id del reporte
  //   //para conseguir  datasetId y embedUrl haremos una llamada a
  //   // https://api.powerbi.com/v1.0/myorg/groups/{groupID}/reports/3a94a87e-a46e-4321-877a-c2819e369851
  //   datasetId: "a57a7bf2-6c96-40b9-adfb-4829fdc8682a", //Necesario para actualizar los datos de la BBDD
  //   embedUrl:
  //     "https://app.powerbi.com/reportEmbed?reportId=3a94a87e-a46e-4321-877a-c2819e369851&groupId=7c809e87-7c80-447f-aa92-9e9c49452d44&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVdFU1QtRVVST1BFLUItUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d",
  //   accessToken:"eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Ik1jN2wzSXo5M2c3dXdnTmVFbW13X1dZR1BrbyIsImtpZCI6Ik1jN2wzSXo5M2c3dXdnTmVFbW13X1dZR1BrbyJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvYWI4NGY0NDQtMmI1MC00YjdkLTkwMmItYzE3ODZjYTFkODdhLyIsImlhdCI6MTcyODM4MzYzNCwibmJmIjoxNzI4MzgzNjM0LCJleHAiOjE3MjgzODgzNzUsImFjY3QiOjAsImFjciI6IjEiLCJhZ2VHcm91cCI6IjMiLCJhaW8iOiJBVlFBcS84WUFBQUEveE5VeGp2WHhqdG43UHBERmUwU0ZocTZQUGFJMGVITjNPRVcxamsxZnZ0enpHNWtiK1AvUnhSNHAwUGVaK1N1L1VlU3NRMjY4dGxIbVVrZjh4VjZLeUl0MzBiRlRORzhPZmcxWEM5VVZQTT0iLCJhbXIiOlsicHdkIiwicnNhIiwibWZhIl0sImFwcGlkIjoiODcxYzAxMGYtNWU2MS00ZmIxLTgzYWMtOTg2MTBhN2U5MTEwIiwiYXBwaWRhY3IiOiIwIiwiZGV2aWNlaWQiOiI2NzMyNzM1My0yMTA3LTQzYjMtYmM1ZC04MTNmMGZkMzg5NmIiLCJmYW1pbHlfbmFtZSI6IlBhcmVkZXMiLCJnaXZlbl9uYW1lIjoiRGFuaWVsIiwiaWR0eXAiOiJ1c2VyIiwiaXBhZGRyIjoiMi4xMzYuMTk3LjcwIiwibmFtZSI6IkRhbmllbCBQYXJlZGVzIiwib2lkIjoiYzg2YWNiMTYtMjVkMi00ODJjLWFhNGItYjAwYTRiNTliOGI2Iiwib25wcmVtX3NpZCI6IlMtMS01LTIxLTM5MjQwMzY3NC0yODk5MDQ0MDAxLTM5NTkzOTk1ODktMTY0NyIsInB1aWQiOiIxMDAzMjAwMjhBNDBCQTlBIiwicmgiOiIwLkFURUFSUFNFcTFBcmZVdVFLOEY0YktIWWVna0FBQUFBQUFBQXdBQUFBQUFBQUFBeEFIYy4iLCJzY3AiOiJ1c2VyX2ltcGVyc29uYXRpb24iLCJzaWduaW5fc3RhdGUiOlsia21zaSJdLCJzdWIiOiJBUDZTMmVVX2hyTTBoQlZMcnU1bEZpbGZTdGZ5YzVEcGJlT05VN21WNmhZIiwidGlkIjoiYWI4NGY0NDQtMmI1MC00YjdkLTkwMmItYzE3ODZjYTFkODdhIiwidW5pcXVlX25hbWUiOiJkYW5pZWwucGFyZWRlc0BhZWlvcm9zLmNvbSIsInVwbiI6ImRhbmllbC5wYXJlZGVzQGFlaW9yb3MuY29tIiwidXRpIjoiVkVUNWsxUDloazJyQjJpZ0xsemZBQSIsInZlciI6IjEuMCIsIndpZHMiOlsiYjc5ZmJmNGQtM2VmOS00Njg5LTgxNDMtNzZiMTk0ZTg1NTA5Il0sInhtc19pZHJlbCI6IjEgMjIifQ.PqvmNNpjH6VOZR253jU9fKnGD0xKuEyjhmkpOHsKoMaH2-",
  //       tokenType: 0,
  //   settings: {
  //     filterPaneEnabled: false,
  //     navContentPaneEnabled: true,
  //   },
  // };

  ngAfterViewInit(): void {
  //  this.embedReport();
  }

  // embedReport() {
  //   const powerbiService = new powerbi.service.Service(
  //     powerbi.factories.hpmFactory,
  //     powerbi.factories.wpmpFactory,
  //     powerbi.factories.routerFactory
  //   );
  //   this.report = powerbiService.embed(
  //     this.reportContainer.nativeElement,
  //     this.embedConfig
  //   );
  // }

  // // Método para actualizar los datos del reporte
  // refreshReport() {

  //   this.report
  //   if (this.report) {
  //     this.powerBiService
  //       .refreshBBDD(this.embedConfig.datasetId, this.embedConfig.accessToken)
  //       .pipe(
  //         finalize(() => {
  //           //una vez ha actualizado los datos de la BBDD forzamos una actualización de los datos cacheados
  //           this.report
  //             .refresh()
  //             .then(() => {
  //               console.log("Reporte actualizado con éxito.");
  //             })
  //             .catch((error) => {
  //               console.error("Error al actualizar el reporte: ", error);
  //             });
  //         })
  //       )
  //       .subscribe(
  //         (response) =>
  //           console.log("Conjunto de datos actualizado con éxito", response),
  //         (error) =>
  //           console.error("Error al actualizar el conjunto de datos", error)
  //       );
  //   }
  // }
}
